module.exports = __webpack_public_path__ + "img/profilo-easyer.b1d178d7.png";